export default __webpack_public_path__ + "static/media/change-pass.85b2a52e.svg";